<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 维保项目管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="项目名称:">
              <el-input placeholder="请输入项目名称" v-model="seefrom.name"></el-input>
            </el-form-item>
            <el-form-item label="单位名称:">
              <el-input placeholder="请输入单位名称" v-model="seefrom.departmentName"></el-input>
            </el-form-item>
            <el-form-item label="开始时间:">
              <el-date-picker v-model="seefrom.startTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择开始时间" style="width:100%">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间:">
              <el-date-picker v-model="seefrom.endTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择结束时间" style="width:100%">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="320">
              <template slot-scope="scope">
                <el-link :icon="scope.row.isStart === 0 ? 'iconfont iconcheck1' : 'iconfont icontingyong'" type="text" size="small"
                  @click="changeStatus(scope.row)">{{ scope.row.isStart === 0 ?'启用': '停用' }}</el-link>
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.$index,  scope.row)">查看</el-link>
                <el-link icon="iconfont iconedit" type="text" size="small" @click="edit(scope.$index, scope.row)">编辑</el-link>
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index,scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
        <addModal v-model="commandDialog" :status="addStatus" :data="detailData" @refresh="getTableData"></addModal>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import addModal from './modal'
import { date } from 'utils'
export default {
  name: 'wbProject',
  data() {
    return {
      key: '',
      tabName: 'jsgl',
      showTable: true,
      other: {},
      seeBtn: true,
      commandDialog: false,
      seefrom: {},
      detailData: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      addStatus: 'adding',
      areaTreeVisible: false
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'createTime',
          label: '创建时间'
        },
        {
          prop: 'name',
          label: '维保项目'
        },
        {
          prop: 'departmentName',
          label: '维保单位'
        },
        {
          prop: 'departmentContacts',
          label: '维保单位联系人'
        },
        {
          prop: 'departmentContactsPhone',
          label: '联系人手机号'
        },
        {
          prop: 'startTime',
          label: '合同开始时间'
        },
        {
          prop: 'endTime',
          label: '合同结束时间'
        }
      ]
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    addModal
  },
  methods: {
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom = {}
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    isMaxGtMin() {
      if (!this.seefrom.startTime || !this.seefrom.endTime) return true
      let s = date(this.seefrom.startTime)
      let e = date(this.seefrom.endTime)
      let ns = [s.YY, s.MM, s.DD].join('')
      let ne = [e.YY, e.MM, e.DD].join('')
      return ne > ns ? true : false
    },
    //查询表格数据
    getTableData() {
      if (this.seefrom.startTime && this.seefrom.endTime) {
        if (!this.isMaxGtMin()) {
          this.$notify({
            message: '开始时间需小于结束时间',
            type: 'warning'
          })
          return
        }
      }
      this.$axiosget('extra/maintenanceProject', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage,
          ...this.seefrom,
          startTime: this.seefrom.startTime
            ? this.seefrom.startTime + ' 00:00:00'
            : undefined,
          endTime: this.seefrom.endTime
            ? this.seefrom.endTime + ' 23:59:59'
            : undefined
        }
      }).then((res) => {
        this.tableData = res.data.data.list
        this.nTotal = res.data.data.total
      })
    },
    //新增
    addnew() {
      this.addStatus = 'adding'
      this.commandDialog = true
    },
    // 详情
    check(index, row) {
      this.detailData = row
      this.addStatus = 'readonly'
      this.commandDialog = true
    },
    // 编辑
    edit(index, row) {
      let data = _.cloneDeep(row)
      this.detailData = data
      this.addStatus = 'editing'
      this.commandDialog = true
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm('删除该条数据?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('extra/maintenanceProject', {
          params: {
            id: row.id
          }
        }).then((res) => {
          if (res.data.status === 10000) {
            this.getTableData()
            this.$message.success('删除成功!')
          }
        })
      })
    },
    changeStatus(row) {
      let mag, status
      if (row.isStart == 0) {
        mag = '启用'
        status = 1
      } else {
        mag = '停用'
        status = 0
      }

      this.$confirm(mag + '该项目?', '操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiospost(
          `extra/maintenanceProject/updateStartStatus?id=${row.id}&isStart=${status}`
        ).then((res) => {
          if (res.data.status == 10000) {
            this.getTableData()
            this.$message({
              type: 'success',
              message: `${mag}成功！`
            })
          }
        })
      })
    }
  },
  created() {
    this.getTableData()
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/wbManage/wbProject/index.vue